import React, { useState } from "react";

// Accept previewThemeKey and setPreviewThemeKey as props!
export default function ThemeModal({
  themes,
  themeKey,
  setThemeKey,
  previewThemeKey,
  setPreviewThemeKey,
  show,
  onClose
}) {
  const [search, setSearch] = useState("");

  // Show filtered themes by search string
  const filtered = Object.entries(themes).filter(([key, theme]) =>
    theme.name.toLowerCase().includes(search.toLowerCase())
  );

  // Show preview theme while hovering, otherwise the real selected theme
  const currentKey = previewThemeKey || themeKey;
  const currentBg = themes[currentKey]?.colors?.background || "#fff";
  const currentText = themes[currentKey]?.colors?.text || "#222";

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-end bg-black bg-opacity-40"
      onClick={() => {
        setPreviewThemeKey(null); // revert to original theme on overlay click
        onClose();
      }}
    >
      <div
        className="relative rounded-xl p-6 w-[420px] mr-8 mt-16 shadow-xl border border-gray-200"
        style={{
          background: currentBg,
          color: currentText,
          transition: "background 0.2s, color 0.2s",
        }}
        onClick={e => e.stopPropagation()} // Prevent click-inside from closing
        onMouseLeave={() => setPreviewThemeKey(null)} // Revert preview if mouse leaves modal
      >
        {/* No close button */}

        <input
          className="w-full px-4 py-2 mb-4 rounded-lg border"
          style={{
            background: currentBg,
            color: currentText,
            border: "1px solid #ddd",
          }}
          autoFocus
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <div className="max-h-[350px] overflow-y-auto">
          {filtered.length === 0 && (
            <div className="text-center text-gray-400 py-8">
              No themes found.
            </div>
          )}
          {filtered.map(([key, theme]) => {
            const mainColor = theme.colors.logoBackground || "#ccc";
            const mainText = theme.colors.logoText || "#fff";
            const isSelected = key === themeKey;

            return (
              <button
                key={key}
                onClick={() => {
                  setThemeKey(key);
                  setPreviewThemeKey(null);
                  onClose();
                }}
                onMouseEnter={() => setPreviewThemeKey(key)}
                onMouseLeave={() => setPreviewThemeKey(null)}
                className="flex items-center justify-between w-full py-2 px-3 rounded-lg mb-1 transition"
                style={{
                  background:
                    previewThemeKey === key || isSelected
                      ? mainColor
                      : undefined,
                  color:
                    previewThemeKey === key || isSelected
                      ? mainText
                      : undefined,
                  border:
                    isSelected
                      ? `2px solid ${mainColor}`
                      : "2px solid transparent",
                  fontWeight: isSelected ? "bold" : "normal",
                  cursor: "pointer",
                }}
              >
                <span>{theme.name}</span>
                <span className="flex gap-1">
                  {theme.swatch?.map((color, i) => (
                    <span
                      key={i}
                      className="inline-block rounded-full"
                      style={{
                        width: 16,
                        height: 16,
                        background: color,
                        border: "1px solid #bbb",
                      }}
                    />
                  ))}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
